import { InjectionToken, Type } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';

export const EMPTY_STATE_IMAGE_URL = 'https://vstatic-prod.apigateway.co/partner-center-client/assets/booking_empty_state.png';

export enum Context {
  SMB = 'smb',
  PARTNER = 'partner',
}

export const MEETING_ANALYSIS_NAMESPACE_INJECTION_TOKEN$: InjectionToken<Observable<string>> = new InjectionToken(
  'MEETING_ANALYSIS_NAMESPACE',
);
export const MEETING_ANALYSIS_CONTEXT_INJECTION_TOKEN$: InjectionToken<Context> = new InjectionToken(
  'Context / Client the library is being used in',
);
export const MEETING_ANALYSIS_USER_ID_INJECTION_TOKEN$: InjectionToken<Observable<string>> = new InjectionToken(
  'MEETING_ANALYSIS_USER_ID',
);
export const MEETING_ANALYSIS_ROUTE_PREFIX$: InjectionToken<string> = new InjectionToken(
  'MEETING_ANALYSIS_ROUTE_PREFIX',
);
export const MEETING_ANALYSIS_NAMESPACE_NAME_INJECTION_TOKEN$: InjectionToken<Observable<string>> = new InjectionToken(
  'MEETING_ANALYSIS_NAMESPACE_NAME',
);
export const MEETING_ANALYSIS_ENABLED_INJECTION_TOKEN$: InjectionToken<Observable<boolean>> = new InjectionToken(
  'sales-coach-enabled',
);

export const SALESPERSON_DIALOG_COMPONENT_TOKEN = new InjectionToken<Type<unknown>>(
  'SALESPERSON_DIALOG_COMPONENT_TOKEN',
);

export const SALESPERSON_DIALOG_CONFIG_TOKEN = new InjectionToken<Observable<MatDialogConfig>>(
  'SALESPERSON_DIALOG_CONFIG_TOKEN',
);
